import React from 'react'
import {Link} from 'gatsby'
import { StMenu } from './style.css'
import { useStaticQuery, graphql } from 'gatsby'

const Menu = ({ active, handleToggleMenu}) => {
  const allPostsTag = useStaticQuery(
    graphql`
		query (
      $tagslug: String = "especial-palestina"
    ) {
		allWordpressPost(
			filter: { tags: { elemMatch: { slug: { eq: $tagslug } } } }
			sort: { fields: date, order: ASC }
		) {
			edges {
				node {
					id
					title
          slug
				}
			}
		}
	}
  `)

  return (
    <StMenu className={active ? `active` : ''}>
      <div className="menu-wrap">
        {allPostsTag.allWordpressPost.edges.map(({ node }, index) =>
          (
            <Link onClick={() => handleToggleMenu()} key={index} className="link" to={`/${node.slug}`} target="_blank" rel="noopener noreferrer">
              <span>&nbsp;</span>
              <span className="tituloRuso">{node.title}</span>
              <span className="tituloEspanol">{node.title}</span>
            </Link>
          )
        )
        }
      </div>
    </StMenu>
  )
}

export default Menu